import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { InvoiceTemplateRow } from "../invoiceTemplates.types";
import { TemplateDateCell } from "./TemplateDateCell";

export const ArchivedCell = memo(function ArchivedCell({
    row,
}: CellContext<ViewTableFeatures, InvoiceTemplateRow, Date | null>) {
    return <TemplateDateCell value={row.original.archivedAt} />;
});
